import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import styled from 'styled-components';
import apiService from "../../services/api_services.js";
import { useNavigate } from 'react-router-dom';
import SamplePrevArrow from "../../components/home/NewArrivals/SamplePrevArrow.js";
import SampleNextArrow from "../../components/home/NewArrivals/SampleNextArrow.js";

// Styled components
const Container = styled.div`
  width: 100%;
  padding-bottom: 4rem;
  text-align: center;
`;

const HeadingStyled = styled.h2`
  font-size: 2rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  position: relative;

  &::after {
    content: '';
    display: block;
    width: 60px;
    height: 4px;
    background-color: #1e81b0;
    margin: 0 auto;
    margin-top: 5px;
  }
`;

const ProductCard = styled.div`
  padding: 1rem;
  background: white;
  border: 1px solid #eaeaea;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  margin: 0 10px;
  position: relative;
  max-width: 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ImageWrapper = styled.div`
  position: relative;
  height: 180px;
  width: 180px;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f9f9f9;

  img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: contain;
    transition: opacity 0.5s ease-in-out;
  }

  img:first-child {
    opacity: 1;
  }

  img:nth-child(2) {
    opacity: 0;
  }

  &:hover img:first-child {
    opacity: 0;
  }

  &:hover img:nth-child(2) {
    opacity: 1;
  }
`;

const Title = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  color: #333;
  margin-top: 0.5rem;
`;

const Description = styled.p`
  color: #777;
  font-size: 0.85rem;
  margin: 0.5rem 0;
  text-align: center;
`;

const Price = styled.p`
  font-size: 1rem;
  font-weight: 700;
  color: #1e81b0;
`;

const SimilarLens = ({ ca_id, pr_id }) => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 2,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      { breakpoint: 1025, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 769, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  const fetchProducts = async () => {
    try {
      const data = await apiService.fetchSimilarProductts(ca_id, pr_id);
      setProducts(data.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, [ca_id, pr_id]);

  const handleCardClick = (product) => {
    navigate(`/product/${product.id}/${product.ca_id}`, { state: { product } });
  };

  if (loading) {
    return <Container>Loading...</Container>;
  }

  if (error) {
    return <Container>Error in Fetching Data: {error}</Container>;
  }

  return (
    <Container>
      <HeadingStyled>Similar Products</HeadingStyled>
      <Slider {...settings}>
        {products.map((product) => {
          const images = JSON.parse(product.images_json || "[]");
          const firstImage = images[0] || "https://via.placeholder.com/150";
          const secondImage = images[1] || firstImage;

          return (
            <div key={product.id}>
              <ProductCard onClick={() => handleCardClick(product)}>
                <ImageWrapper>
                  <img src={firstImage} alt={product.name || "Product Image"} />
                  <img src={secondImage} alt={product.name || "Product Hover Image"} />
                </ImageWrapper>
                <Title>{product.name}</Title>
                {/* <Description>{product.description}</Description> */}
                <Price>₹{product.sale_price || product.price}</Price>
              </ProductCard>
            </div>
          );
        })}
      </Slider>
    </Container>
  );
};

export default SimilarLens;
